export interface Customer {
  id: string;
  email: string;
  firstName: string;
  lastName: string;
  displayName: string;
  numberOfOrders: number;
  phone: string | null;
}

export interface CustomerSession {
  customer: Customer | null;
  accessToken: string | null;
  sessionType: 'local' | 'oauth' | null;
}

export const GUEST_SESSION: CustomerSession = { customer: null, accessToken: null, sessionType: null };

/** Cookie contents stay HttpOnly; only the server decides if a local lookup is needed. */
export async function restoreCustomerSession(base: string, request: typeof fetch = fetch): Promise<CustomerSession> {
  const options: RequestInit = { credentials: 'include', cache: 'no-store' };
  try {
    const response = await request(`${base}/api/auth/session`, options);
    if (response.ok) {
      const data = await response.json() as { customer: Customer | null; hasLocalSession?: boolean };
      if (data.customer) return { customer: data.customer, accessToken: null, sessionType: 'oauth' };
      if (data.hasLocalSession === false) return GUEST_SESSION;
    }
  } catch {
    // A failed OAuth check (or an older backend without the hint) still permits local login.
  }
  try {
    const response = await request(`${base}/api/shopify/customer/me`, options);
    if (response.ok) {
      const data = await response.json() as { authenticated: boolean; customer: Customer | null };
      if (data.authenticated && data.customer) {
        return { customer: data.customer, accessToken: null, sessionType: 'local' };
      }
    }
  } catch {
    // A network failure must not break browsing or the sign-in form.
  }
  return GUEST_SESSION;
}
